<template>
  <div class="view">
    <!-- <el-button>扫码</el-button>
    <span>参数:{{ Code }}</span> -->
    <div class="pro">
      <div class="bt">
        <div class="title">妥思空调</div>
        <div class="desc">型号：KF-25GW/PBCA-R5</div>
      </div>
      <div class="lunbo">
        <div class="lb">
          <el-carousel height="5rem" :interval="5000" arrow="always">
            <el-carousel-item>
              <img src="@/assets/kt.png" />
            </el-carousel-item>
            <el-carousel-item>
              <img src="@/assets/kt.png" />
            </el-carousel-item>
            <el-carousel-item>
              <img src="@/assets/kt.png" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>

      <div class="content">
        <div class="list">
          <div class="item">
            <span>产品介绍</span>
            <span><i class="el-icon-arrow-right"></i></span>
          </div>
          <div class="item">
            <span>快速入门</span>
            <span><i class="el-icon-arrow-right"></i></span>
          </div>
          <div class="item">
            <span>联网指引</span>
            <span><i class="el-icon-arrow-right"></i></span>
          </div>
          <div class="item">
            <span>清洁保养</span>
            <span><i class="el-icon-arrow-right"></i></span>
          </div>
          <div class="item">
            <span>常见问题</span>
            <span><i class="el-icon-arrow-right"></i></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import "@/utils/flexible.js"
  import { GetPlaceSearchMap } from "@/api/test"
  export default {
    name: "index",
    data() {
      return {
        Code: "",
      }
    },
    created() {
      console.log("created", 1)
      const queryUrl = this.getRequest()
      console.log(queryUrl.code)
      this.Code = queryUrl.code
    },
    mounted() {},
    methods: {
      getRequest() {
        var url = decodeURIComponent(location.search)
        var theRequest = new Object()
        if (url.indexOf("?") != -1) {
          var str = url.substr(1)
          var strs = str.split("&")
          for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1])
          }
        }
        return theRequest
      },

      async Test() {
        const res = await GetPlaceSearchMap("苏州市", "")
        console.log(res)
      },
    },
  }
</script>

<style scoped lang="scss">
  .view {
    .pro {
      display: flex;
      flex-direction: column;
      padding: 0.3rem 0 0 0;
      .title {
        font-size: 0.45rem;
        text-align: center;
      }
      .desc {
        font-size: 0.3rem;
        text-align: center;
        margin: 0.3rem 0 0 0;
      }
    }
    .lunbo {
      margin: 0.5rem 0 0 0;
      .lb {
        width: 95%;
        margin: auto;
        // border: 1px solid #000000;
        img {
          width: 100%;
          height: 4.5rem;
        }
      }
    }
    .content {
      margin: 0.5rem 0 0 0;
      .list {
        width: 95%;
        margin: auto;
        display: flex;
        flex-direction: column;
        .item {
          height: 2rem;
          background: linear-gradient(to right, #ff0000, #c48383);
          border-radius: 0.5rem;
          margin: 0 0 0.3rem 0;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          span:nth-child(1) {
            font-size: 0.45rem;
            color: #ffffff;
            margin: 0 0 0 0.3rem;
          }
          span:nth-child(2) {
            color: #ffffff;
            font-size: 0.45rem;
            margin: 0 0.3rem 0 0;
          }
        }
        .item:nth-child(2) {
          background: linear-gradient(to right, #0f21ab, #5a67b0);
        }
        .item:nth-child(3) {
          background: linear-gradient(to right, #1d9b09, #65d376);
        }
        .item:nth-child(4) {
          background: linear-gradient(to right, #981477, #d567d2);
        }
        .item:nth-child(5) {
          background: linear-gradient(to right, #c9c614, #d6cd6f);
        }
      }
    }
  }
</style>
